import { cardUITransformer } from './card/cardUITransformer';
import {
  jobsTrendTransformer,
  offersTrendTransformer,
  contactsTrendTransformer,
  hiresTrendTransformer,
  interviewsTrendTransformer,
  rejectionsTrendTransformer,
  pipelineChartTransformer,
  liveJobPipelineChartTransformer,
  flowCandidateTouchPointTransformer,
  flowUserActivityTransformer,
} from './chartTrend';
import { requisitionsTrendTransformer } from './chartTrend/requisitionsTrendTransformer';
import {
  interviewsVisualsTransformer,
  rejectionsReasonsTransformer,
} from './chartVisuals';
import { hiresVisualsTransformer } from './chartVisuals/hiresVisualsTransformer';
import { jobsVisualsTransformer } from './chartVisuals/jobsVisualsTransformer';
import { offersVisualsTransformer } from './chartVisuals/offersVisualsTransformer';
import { rejectionsVisualsTransformer } from './chartVisuals/rejectionsVisualsTransformer';
import { requisitionsVisualsTransformer } from './chartVisuals/requisitionsVisualsTransformer';
import { requisitionsPieTransformer } from './chartVisuals/requisitionsPieTransformer';
import {
  pipelineTableTransformer,
  liveJobPipelineTableTransformer,
  interviewsTableTransformer,
  offersTableTransformer,
  hiresTableTransformer,
  rejectionsTableTransformer,
  contactsTableTransformer,
  jobsTableTransformer,
  eeoTableTransformer,
  flowUserActivityTableTransformer,
  flowUserCandidateTouchPointTransformer,
} from './table';
import { performanceTableTransformer } from './table/performanceTableTransformer';
import { requisitionsTableTransformer } from './table/requisitionsTableTransformer';
import { npsScoreTransformer } from './npsScore/npsScoreTransformer';
import { npsChartTransformers } from './chart/npsChartTransformers';
import { surveyTableTransformer } from './table/surveyTableTransformer';

// Define a mapping of transformer keys to transformation functions
const transformerMap: Record<
  string,
  (_data: unknown, _args?: unknown) => unknown
> = {
  card: cardUITransformer,

  // nps score
  nps_score: npsScoreTransformer,

  // pipeline chart
  pipeline_chart: pipelineChartTransformer,
  live_job_pipeline_chart: liveJobPipelineChartTransformer,

  //interview charts
  interviews_trend_chart: interviewsTrendTransformer,
  interviews_feedback_chart: interviewsVisualsTransformer,
  interviews_duration_chart: interviewsVisualsTransformer,

  //offer charts
  offers_trend_chart: offersTrendTransformer,
  offers_department_chart: offersVisualsTransformer,
  offers_location_chart: offersVisualsTransformer,

  //hires charts
  hires_trend_chart: hiresTrendTransformer,
  requisitions_trend_chart: requisitionsTrendTransformer,
  hires_department_chart: hiresVisualsTransformer,
  hires_source_chart: hiresVisualsTransformer,

  //rejection charts
  rejections_trend_chart: rejectionsTrendTransformer,
  we_rejected_them: rejectionsReasonsTransformer,
  they_rejected_us: rejectionsReasonsTransformer,
  others: rejectionsReasonsTransformer,
  rejection_by_source: rejectionsVisualsTransformer,
  rejection_by_stage: rejectionsVisualsTransformer,

  //contact chart
  contacts_chart: contactsTrendTransformer,

  //jobs charts
  jobs_trend_chart: jobsTrendTransformer,
  jobs_department_chart: jobsVisualsTransformer,
  jobs_location_chart: jobsVisualsTransformer,

  //flow charts
  flow_candidate_touchpoint_chart: flowCandidateTouchPointTransformer,
  flow_user_activity_chart: flowUserActivityTransformer,

  requisitions_by_department: requisitionsVisualsTransformer,
  requisitions_by_requisition_type: requisitionsVisualsTransformer,
  requisitions_by_department_pie: requisitionsPieTransformer,

  // survey charts
  survey_candidate_nps_chart: npsChartTransformers,
  survey_hm_nps_chart: npsChartTransformers,

  // table
  pipeline_table: pipelineTableTransformer,
  live_job_pipeline_table: liveJobPipelineTableTransformer,
  interviews_table: interviewsTableTransformer,
  offers_table: offersTableTransformer,
  hires_table: hiresTableTransformer,
  rejections_table: rejectionsTableTransformer,
  contacts_table: contactsTableTransformer,
  jobs_table: jobsTableTransformer,
  eeoc_race_table: eeoTableTransformer,
  eeoc_veteran_table: eeoTableTransformer,
  eeoc_disability_table: eeoTableTransformer,
  flow_health: flowUserCandidateTouchPointTransformer,
  flow_user_activity: flowUserActivityTableTransformer,
  recruiter_performance_table: performanceTableTransformer,
  requisitions_table: requisitionsTableTransformer,
  // todo: need to implement survey table transformer
  survey_table: surveyTableTransformer, //surveyTableTransformer,
};

const transformerKeyMap = {
  card: 'card',
  nps_score: 'nps_score',
};

export const transformData = ({
  metadata,
  apiData,
  currentFilter,
  tile,
  subject_type = '',
}) => {
  const { componentType, tileKey } = metadata || {};

  const transformerKey = transformerKeyMap[componentType] || tileKey;

  const transformFunction = transformerMap[transformerKey];

  if (transformFunction) {
    return transformFunction({
      response: apiData,
      metadata,
      args: currentFilter,
      tile,
      subject_type,
    }); // Call the respective transformer function
  }

  return apiData; // Fallback to raw data if no transformer matches
};
